export enum UpdatePageTabKey {
  CONTENT = 'content',
  GALLERY = 'gallery',
  BANNER = 'banner',
  SEO = 'seo',
}

export enum UpdatePageInput {
  TITLE = 'title',
  DESCRIPTION = 'description',
  KEYWORDS = 'keywords',
  TEXT = 'text',
  TIPS = 'tips',
  CALL = 'call',
  BLOCKS = 'blocks',
  IMAGE = 'image',
  IMAGE_NAME = 'imageName',
  LINK = 'link',
  ID = 'id',
  NOT_FOUND_MESSAGE = 'notFoundMessage',
  NOT_FOUND_AND_CONTACT_SUPPORT_HINT = 'notFoundAndContactSupportHint',
  HEADER = 'header',
  FILE = 'file',
}
